import React from "react";
import {
  Text,
  Stack,
  Switcher,
  Box,
  BankGenericSmallIcon,
  Cluster,
  ExternalLink,
} from "@thecb/components";
import { SEMI_BOLD } from "@/constants/fonts";
import DisplayValue from "@/components/generic/DisplayValue";

const BankAccountDetails = ({
  paymentType,
  bankAccount,
  specificParams,
  checkImageUrlFront,
  checkImageUrlBack,
}) => {
  const unavailableMessage = "Not available";

  const lastFour = bankAccount?.lastFour?.value ?? null;
  // Unused var type while hiding bank account type information
  // const type = S.fromMaybe("")(bankAccount.type);
  const bankAccountHolderName =
    bankAccount?.bankAccountHolderName?.value ?? unavailableMessage;
  const emailAddress = specificParams?.emailAddress?.value ?? unavailableMessage;

  const checkImageLinks = (
    <Cluster>
      <ExternalLink
        newTab
        href={checkImageUrlFront}
        lineHeight="1.25rem"
        extraStyles="text-decoration: none;"
      >
        <Text variant="pS" color="inherit">
          Front
        </Text>
      </ExternalLink>
      <Box padding="0px 8px">
        <Text variant="pS">|</Text>
      </Box>
      <ExternalLink
        newTab
        href={checkImageUrlBack}
        lineHeight="1.25rem"
        extraStyles="text-decoration: none;"
      >
        <Text variant="pS" color="inherit">
          Back
        </Text>
      </ExternalLink>
    </Cluster>
  );

  return (
    <Stack childGap="0.5rem">
      <DisplayValue title="Payment method type" value={paymentType} />
      {checkImageUrlFront && checkImageUrlBack && (
        <DisplayValue title="Check images" value={checkImageLinks} />
      )}
      <Switcher
        breakpoint="700px"
        childGap="0.25rem"
        largeChild={2}
        largeChildSize={5}
      >
        <Text variant="pS" weight={SEMI_BOLD} extraStyles="flex-basis: 17rem;">
          Payment method
        </Text>
        <Box padding="0" extraStyles="display: flex; align-items: center;">
          {lastFour && <BankGenericSmallIcon />}
          <Text variant="pS" extraStyles={lastFour && "padding-left: 0.5rem;"}>
            {lastFour ? `Bank account ending in ${lastFour}` : unavailableMessage}
          </Text>
        </Box>
      </Switcher>
      <DisplayValue title="Name" value={bankAccountHolderName} />
      <DisplayValue title="Receipt email address" value={emailAddress} />
    </Stack>
  );
};

export default BankAccountDetails;
